<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6"
          class="py-6 px-md-6"
          v-for="(item, i) in filteredCategories"
          :key="i"
        >
          <!-- <div class="rowinfo"> -->
          <cat-card :item="item">
            <template>
              <help-info
                :element-name="`${serviceName}-${componentName}-catBusinessShop-${item.route}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${item.name}`"
                :style="{
                  opacity: item.comingSoon ? 0.2 : 1,
                  'pointer-events': item.comingSoon ? 'none' : 'auto',
                  top: '46%',
                  boxShadow: 'none',
                  left: '4%',
                  position: 'relative',
                }"
              />
            </template>
          </cat-card>
          <!-- </div> -->
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CatCard from "./catCard";

export default {
  name: "catNotices",
  components: { CatCard },
  data: () => ({
    serviceName: "Qrland",
    componentName: "catNotices",
    helpData: [],
  }),
  computed: {
    categories() {
      return [
        {
          name: this.$t("categories.invitation_card"),
          value: "",
          route: "qr.link",
          colors: ["#e43a15", "#e65245", "#e43a15"],
          icon: "mdi-email-open-heart-outline",
          comingSoon: true,
        },
        {
          name: this.$t("categories.countdown"),
          value: "",
          route: "qr.link",
          colors: ["#6a3093", "#a044ff", "#6a3093"],
          icon: "mdi-timer-check-outline",
          comingSoon: true,
        },
      ];
    },
    filteredCategories() {
      const currentLocale = this.$i18n.locale;
      if (currentLocale === "fa") {
        return this.categories;
      }
      return this.categories.map((x) => ({
        ...x,
        comingSoon: true,
      }));
      // return [];
    },
  },

  watch: {
    "$i18n.locale": {
      handler(newLocale) {
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
